import React, { createContext, useContext, useState } from 'react';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [roles, setRoles] = useState([]);
  const [userId, setUserId] = useState(null);  // <-- added userId here

  console.log('AuthContext token:', token, 'userId:', userId);

  const value = {
    token,
    setToken,
    roles,
    setRoles,
    userId,
    setUserId,   // expose setter so you can set userId after login
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
